import { render, staticRenderFns } from "./ProvisioningNoticePage.vue?vue&type=template&id=f63bcaf0&scoped=true&"
import script from "./ProvisioningNoticePage.vue?vue&type=script&lang=js&"
export * from "./ProvisioningNoticePage.vue?vue&type=script&lang=js&"
import style0 from "./ProvisioningNoticePage.vue?vue&type=style&index=0&id=f63bcaf0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63bcaf0",
  null
  
)

export default component.exports